export default "__VITE_ASSET__CJyY_urT__"